import React from "react";

function Lodingpage() {
  return (
    <div className="loding">
      <div className="lodingpage">
        <span>is</span>
        <span>in</span>
        <span>Loading...!</span>
      </div>
    </div>
  );
}

export default Lodingpage;
